angular.module('ihestiaWidgets.ikonfigurator')
  .factory('ikonfiguratorReadOfferModalHelper', [function(){
      var IkonfiguratorReadOfferModalHelper = function(){
        this.readOfferData = {
          dataSetNumber: ''
        };
      };

      return new IkonfiguratorReadOfferModalHelper();
  }]);